import { ChevronRight } from 'lucide-react'

interface BreadcrumbsProps {
    path: string
    onNavigate: (path: string) => void
}

export function Breadcrumbs({ path, onNavigate }: BreadcrumbsProps) {
    // Split path into segments, filtering out empty strings
    const segments = path.split('/').filter(Boolean)

    // Build cumulative paths for each segment
    const paths = segments.map((_, index) => {
        return '/' + segments.slice(0, index + 1).join('/')
    })

    return (
        <nav className="flex items-center gap-1 px-4 py-2 text-sm bg-gray-50 dark:bg-black border-b border-gray-200 dark:border-gray-800">
            {/* Root / Arquivos */}
            <button
                onClick={() => onNavigate('/')}
                className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors px-1 py-0.5 rounded hover:bg-gray-100 dark:hover:bg-gray-700"
            >
                Arquivos
            </button>

            {/* Path segments */}
            {segments.map((segment, index) => (
                <div key={index} className="flex items-center gap-1">
                    <ChevronRight size={14} className="text-gray-400 dark:text-gray-600" />
                    <button
                        onClick={() => onNavigate(paths[index])}
                        className={`px-1 py-0.5 rounded transition-colors ${index === segments.length - 1
                            ? 'text-gray-900 dark:text-gray-100 font-medium'
                            : 'text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                            }`}
                    >
                        {segment}
                    </button>
                </div>
            ))}
        </nav>
    )
}
